import { activateItems, theaterPause, theaterPlay } from './activate';
import { content } from './content';
import { selectors } from './lib';
import * as Utils from './utils';

// Checks if the first element already has the loaded flag and if not, loops the query until it arrives.
const firstElementLoaded = (elem) => {
	const interval = setInterval(() => {
		if (elem.loaded) {
			const ctr = elem.ctr.closest(selectors.primaryCtr);
			clearInterval(interval);
			theaterPlay(elem, ctr.id);

			return elem;
		}
	}, 100);
};

const intersectionCallback = (entries) => {
	entries.forEach((entry) => {
		let elem = entry.target;
		const ctr = elem.closest(selectors.primaryCtr);
		const index = Utils.getIndex(elem);

		let contentElm = content[ctr.id].objs[index];

		if (entry.isIntersecting) {
			activateItems(ctr.id, index);
			if (contentElm.loaded) {
				theaterPlay(contentElm, ctr.id);
			}
		} else {
			if (contentElm.loaded) {
				theaterPause(contentElm, ctr.id);
			}
		}

		// When the IntersectionObserver checks what is in the viewport, the content does not necessarily have to be loaded.
		// Therefore, the first element must be verified to be loaded and then played.
		if (contentElm.loaded === false) {
			firstElementLoaded(contentElm);
		} else {
			theaterPlay(contentElm, ctr.id);
		}
	});
};

export const mobileScrollObserver = (ctr) => {
	let options = {
		root: ctr,
		rootMargin: '0px',
		threshold: 0.9,
	};
	let observer = new IntersectionObserver(intersectionCallback, options);
	let targets = ctr.querySelectorAll(selectors.nav);

	targets.forEach((t) => {
		observer.observe(t);
	});
};
